import { focusOutline } from '@apia/theme';
import { ThemeUICSSObject } from '@apia/theme';

export const styles: ThemeUICSSObject = {
  '&, *': {
    textAlign: 'center',
  },

  '.iconsList__icon__image__wrapper': {
    boxShadow: '1px 1px 3px #0001',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  '.iconsList__icon__image': {
    maxWidth: 'calc(100% - 4px)',
  },

  '.iconsList__icon__wrapper': {
    p: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 3,

    '&:hover': (theme) => {
      return {
        ...theme.palette.getOneState(
          { backgroundColor: 'palette.background.paper' },
          'hover',
        ),
      };
    },
  },

  '.iconsList__icon__label': {
    wordBreak: 'break-word',
    display: '-webkit-box',
    WebkitLineClamp: '3',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: '20px',
  },

  '.iconsList__keyHandler:focus': {
    outline: 'none',

    '.focused .iconsList__icon__wrapper': {
      ...focusOutline,
    },
  },
};
